/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ApplicantInputs */

const en_applicant = /** @type {(inputs: ApplicantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicant`)
};

const de_applicant = /** @type {(inputs: ApplicantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerber`)
};

/**
* | output |
* | --- |
* | "Applicant" |
*
* @param {ApplicantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicant = /** @type {((inputs?: ApplicantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ApplicantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicant(inputs)
	return en_applicant(inputs)
});